import { useState, createContext } from 'react';

import { CRUDableType } from '@/meta';

export interface Creatable {
  type: CRUDableType;
  capability?: FieldOption<string> & { publicId: string };
}

export type CreateDispatch = {
  dispatch: (arg: Partial<Creatable>) => void;
};

function useCreateEntityController(): Creatable & CreateDispatch {
  const [state, setState] = useState<Creatable>({
    type: 'capability',
  });

  return {
    ...state,
    dispatch: (newState: Creatable) => setState(newState),
  };
}

export const CreateEntityContext = createContext<Creatable & CreateDispatch>({
  type: 'capability',
  dispatch: () => {},
});

export default useCreateEntityController;
